import { createFileRoute, redirect } from "@tanstack/react-router";
import { authClient } from "../lib/auth-client.ts";

export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    const { data: session } = await authClient.getSession();
    if (!session?.user) throw redirect({ to: "/sign-in" });
    const role = (session.user as { role?: string }).role;
    if (role === "worker") throw redirect({ to: "/work", search: {} });
    throw redirect({ to: "/admin/uren" });
  },
});
